import { jsxs, jsx } from "react/jsx-runtime";
const IllustrationVerifiedListingSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 64,
    height: 64,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.317 22.185a1 1 0 0 0-.8-.321l-1.68.106a1 1 0 0 1-1.021-.712l-.484-1.623a1 1 0 0 0-.576-.638l-1.548-.64a1 1 0 0 1-.606-1.08l.269-1.711a1 1 0 0 0-.237-.815L.51 13.473a1 1 0 0 1-.076-1.221l.989-1.458a1 1 0 0 0 .137-.827L1.1 8.29a1 1 0 0 1 .456-1.126l1.515-.894a1 1 0 0 0 .476-.685l.31-1.737a1 1 0 0 1 .9-.82l1.72-.147a1 1 0 0 0 .73-.417l1.017-1.431A1 1 0 0 1 9.4.679l1.574.61a1 1 0 0 0 .851-.06l1.5-.842a1 1 0 0 1 1.225.196l1.133 1.232a1 1 0 0 0 .799.321l1.68-.106a1 1 0 0 1 1.021.712l.484 1.623a1 1 0 0 0 .576.638l1.548.64a1 1 0 0 1 .606 1.08l-.269 1.711a1 1 0 0 0 .237.815l1.123 1.278a1 1 0 0 1 .076 1.221l-.989 1.458a1 1 0 0 0-.137.827l.461 1.678a1 1 0 0 1-.456 1.126l-1.515.894a1 1 0 0 0-.476.685l-.31 1.737a1 1 0 0 1-.9.82l-1.72.147a1 1 0 0 0-.73.417l-1.017 1.431a1 1 0 0 1-1.177.353l-1.574-.61a1 1 0 0 0-.851.06l-1.5.841a1 1 0 0 1-1.225-.195l-1.132-1.232Z",
          fill: "#FE5F55"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.603 16.02a.993.993 0 0 1-.086-.079l-2.236-2.325a1.026 1.026 0 0 1 0-1.41l.01-.012a.933.933 0 0 1 1.357 0l1.663 1.73 5.508-5.73a.635.635 0 0 1 .914 0l.447.466a.634.634 0 0 1 0 .878l-6.448 6.706a.633.633 0 0 1-.914 0l-.215-.224Z",
          fill: "#fff"
        }
      )
    ]
  }
);
export {
  IllustrationVerifiedListingSvg
};
